import styled from 'styled-components';

export const AddBtn = styled.button`
  width: 80px;
  height: 25px;
  padding: 5px;
  background-color: #00ffff;
  cursor: pointer;
  border-radius: 5px;

  &:hover {
    background-color: #0c7979;
  }
`;

export const DeleteBtn = styled.button`
  width: 80px;
  height: 25px;
  padding: 5px;
  background-color: aqua;
  cursor: pointer;
  border-radius: 5px;

  &:hover {
    background-color: #ff0000;
  }
`;
